/**
 * @desc 三方配送路由
 * @date 2020-04-15
 * @author billy
 */
export const delivery = [
  {
    path: '/digitalMarketing/multiplatformDelivery',
    name: 'multiplatformDelivery',
    component: () => import('views/digitalMarketing/multiplatformDelivery'),
    meta: {
      title: '三方配送'
    }
  },
  {
    path: '/openingDelivery',
    name: 'openingDelivery',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery'),
    meta: {
      title: '填写资料',
      keepAlive: true
    }
  },
  {
    path: '/openingDelivery/balanceDetailed',
    name: 'balanceDetailed',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/balanceDetailed'),
    meta: {
      title: '余额明细',
      keepAlive: true
    }
  },
  {
    path: '/openingDelivery/balanceDetailed/chooseConditions',
    name: 'chooseConditions',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/balanceDetailed/chooseConditions'),
    meta: {
      title: '筛选'
    }
  },
  {
    path: '/openingDelivery/balanceDetailed/balanceTradeDetail',
    name: 'balanceTradeDetail',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/balanceDetailed/detail'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/openingDelivery/detail',
    name: 'storeDetail',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/detail'),
    meta: {
      title: '门店详情'
    }
  },
  {
    path: '/openingDelivery/reSubmit',
    name: 'reSubmit',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/reSubmit'),
    meta: {
      title: '重新提交',
      keepAlive: true
    }
  },
  {
    path: '/openingDelivery/edSubmit',
    name: 'edSubmit',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/editSubmit'),
    meta: {
      title: '修改门店信息',
      keepAlive: true
    }
  },
  {
    path: '/openingDelivery/recharge',
    name: 'recharge',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/recharge'),
    meta: {
      title: '充值'
    }
  },
  {
    path: '/openingDelivery/valuationRules',
    name: 'valuationRules',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/valuationRules'),
    meta: {
      title: '计价规则'
    }
  },
  {
    path: '/openingDelivery/agreement',
    name: 'agreement',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/agreement'),
    meta: {
      title: '第三方配送服务协议'
    }
  },
  {
    path: '/openingDelivery/address',
    name: 'address',
    component: () => import('views/digitalMarketing/multiplatformDelivery/openingDelivery/address'),
    meta: {
      title: '门店地址'
    }
  }
]
